import type { JSX } from 'react';

export enum EnumTipoNotificacion {
    Error = 1,
    Warning = 2,
    Success = 3,
    Information = 4
}

export interface IPaginacion {
    Total: number;
    Page: number;
    Size: number;
    TotalPages: number;
    HasNext: boolean;
    HasPrevious: boolean;
}

export interface IFiltroPaginador {
    Page: number;
    Size: number;
}

export interface IRespuestaApiObjeto<T> {
    Data: T;
    Messages: string[];
    NotificationType: EnumTipoNotificacion;
    Pagination: IPaginacion;
}

export interface IRespuestaApiLista<T> {
    Data: T[];
    Messages: string[];
    NotificationType: EnumTipoNotificacion;
    Pagination: IPaginacion;
}


export interface IRespuestaApiLista<T> {
    Data: T[];
    Messages: string[];
    NotificationType: EnumTipoNotificacion;
    Pagination: IPaginacion;
}

export interface IRuta {
    Ruta: string;
    NombreModulo: string;
    Icono: React.ReactNode;
    Componente: JSX.Element;
    Activa: boolean;
    PermisoRequerido: string; // Código del permiso requerido para acceder al módulo
    OcultoEnMenu?: boolean; // Permite registrar la ruta pero ocultarla del menú principal
}


export interface OpcionSelect {
    id: string;
    label: string;
    colorLabelTag?: string
    colorTag?: string; // opcional, solo si usas tags
    icono?: React.ReactNode; // opcional, solo si usas tags
}

export interface ICatalogo {
    Id: number;
    Nombre: string;
}

// Exportar el contexto de notificaciones
// export { NotificationProvider, useNotifications } from '../contextos/notificationContext';
